export default __webpack_public_path__ + "static/media/data-analysis-with-python.8a7d1f0d.png";